import React from 'react';
const AddressSearchItem = (props) => {
    return (React.createElement("li", { id: 'autocomplete-option-' + props.index, role: "option", className: props.focused ? 'focused' : undefined, "aria-selected": props.focused, onClick: (e) => props.selectSuggestion(props.item), onMouseEnter: props.onMouseEnter, onKeyDown: () => {
            //do
        } }, props.suggestionText(props.item)));
};
export default AddressSearchItem;
